class BundleCarousel extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick.bind(this));
    this.addEventListener('change', this.#handleChange.bind(this));
    this.#initArrows();
    this.#initZoom();
    this.#initSizeSelects();
  }

  #initSizeSelects() {
    const filterSize = (this.dataset.filterSize || '').trim();
    if (!filterSize) return;
    this.querySelectorAll('.czb-card').forEach(card => {
      const select = card.querySelector('.czb-card__size');
      const addBtn = card.querySelector('.czb-card__add');
      if (!select || !addBtn) return;
      // Chercher l'option dont le texte correspond à la taille du panier
      const opt = Array.from(select.options).find(o => o.text.trim() === filterSize);
      if (opt) {
        select.value = opt.value;
        addBtn.dataset.variantId = opt.value;
      }
    });
  }

  #initZoom() {
    let lb = null;
    this.addEventListener('mouseover', (e) => {
      const zoom = e.target.closest('.czb-card__zoom');
      if (!zoom) return;
      const img = zoom.closest('.czb-card__img')?.querySelector('img');
      if (!img) return;
      // Image en haute résolution
      const src = img.src.replace(/width=\d+/, 'width=480');
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'czb-lightbox';
        lb.innerHTML = '<img>';
        document.body.appendChild(lb);
      }
      lb.querySelector('img').src = src;
      // Position : au-dessus et centré sur la loupe
      const r = zoom.getBoundingClientRect();
      const lw = 280, lh = 280;
      let top  = r.top - lh - 10;
      let left = r.left + r.width / 2 - lw / 2;
      if (top < 8) top = r.bottom + 10;
      if (left < 8) left = 8;
      if (left + lw > window.innerWidth - 8) left = window.innerWidth - lw - 8;
      lb.style.top  = top  + 'px';
      lb.style.left = left + 'px';
      lb.classList.add('is-visible');
    });
    this.addEventListener('mouseout', (e) => {
      if (!lb) return;
      const from = e.target.closest('.czb-card__zoom');
      const to   = e.relatedTarget?.closest?.('.czb-card__zoom');
      if (from && !to) lb.classList.remove('is-visible');
    });
  }

  #initArrows() {
    const track = this.querySelector('.czb__track');
    const prev  = this.querySelector('.czb__arrow--prev');
    const next  = this.querySelector('.czb__arrow--next');
    if (!track || !next) return;
    const update = () => {
      const atStart = track.scrollLeft <= 4;
      const atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prev) prev.hidden = atStart;
      if (next) next.hidden = atEnd;
    };
    track.addEventListener('scroll', update, { passive: true });
    update();
    prev?.addEventListener('click', (e) => {
      e.stopPropagation();
      track.scrollBy({ left: -110, behavior: 'smooth' });
    });
    next?.addEventListener('click', (e) => {
      e.stopPropagation();
      track.scrollBy({ left: 110, behavior: 'smooth' });
    });
  }

  #handleClick(e) {
    if (e.target.closest('.czb-card__zoom')) { e.preventDefault(); return; }
    const swatch = e.target.closest('.czb-swatch');
    if (swatch) { this.#selectSwatch(swatch); return; }
    const addBtn = e.target.closest('.czb-card__add');
    if (addBtn) { e.preventDefault(); this.#addToCart(addBtn); }
  }

  #handleChange(e) {
    const select = e.target.closest('.czb-card__size');
    if (!select) return;
    const card = select.closest('.czb-card');
    card.querySelector('.czb-card__add').dataset.variantId = select.value;
  }

  #selectSwatch(swatch) {
    const card = swatch.closest('.czb-card');
    card.querySelectorAll('.czb-swatch').forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');

    const jsonEl = card.querySelector('.czb-card__variants-json');
    if (!jsonEl) return;
    let variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch { return; }

    const color      = swatch.dataset.color;
    const filterSize = this.dataset.filterSize || '';

    // Filtrer par couleur uniquement
    const colorVars = variants.filter(v =>
      (v.o1 || '').toLowerCase().replace(/ /g, '-') === color
    );
    if (!colorVars.length) return;

    // Dédupliquer par taille
    const seen = new Set();
    const uniqueSizes = colorVars.filter(v => {
      if (seen.has(v.o2)) return false;
      seen.add(v.o2); return true;
    });

    const addBtn     = card.querySelector('.czb-card__add');
    const sizeSelect = card.querySelector('.czb-card__size');
    if (sizeSelect) {
      sizeSelect.innerHTML = uniqueSizes
        .map(v => `<option value="${v.id}"${filterSize && v.o2 === filterSize ? ' selected' : ''}>${v.o2 || ''}</option>`)
        .join('');
    }
    // Variant par défaut : taille filtrée si dispo, sinon premier
    const preferred = filterSize ? colorVars.find(v => v.o2 === filterSize) : null;
    addBtn.dataset.variantId = (preferred || colorVars[0]).id;

    if (colorVars[0].img) {
      const img = card.querySelector('img');
      if (img) img.src = colorVars[0].img;
    }
  }

  async #addToCart(btn) {
    const variantId = parseInt(btn.dataset.variantId);
    if (!variantId || isNaN(variantId)) return;
    btn.classList.add('is-loading');

    const cartDrawer = document.querySelector('cart-drawer');
    const sectionId  = cartDrawer?.dataset?.sectionId;
    const sections   = sectionId ? `auto-gifts,${sectionId}` : 'auto-gifts';

    try {
      // Ajouter au panier avec section pour le re-render
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections })
      });
      const addData = await res.json();
      if (addData.status === 422 || addData.description) {
        console.warn('[bundle-carousel] add error:', addData);
        return;
      }

      // Récupérer le vrai item count (le add.js ne le fournit pas)
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      // Dispatcher cart:updated avec le count correct (évite le bug "cart vide")
      if (addData.sections && sectionId) {
        const ev = Object.assign(new Event('cart:updated', { bubbles: true }), {
          detail: {
            resource: addData,
            data: {
              sections: addData.sections,
              itemCount: cart.item_count,
              source: 'bundle-carousel'
            }
          }
        });
        document.dispatchEvent(ev);
      }

    } catch (err) {
      console.error('[bundle-carousel]', err);
    } finally {
      btn.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('bundle-carousel')) {
  customElements.define('bundle-carousel', BundleCarousel);
}
